import React, {useEffect, type FC} from 'react'
import clsx from 'clsx'
import {useAppDispatch} from 'store'
import {hideModalThunk} from 'store/modal/thunk'
import type {HintModal as HintModalType} from 'store/modal/entities'
import {ModalWrap} from '../../ModalWrap'
import styles from './hintmodal.scss'

const TIME_SHOW_HINT = 500

export const HintModal: FC<HintModalType['props']> = ({type, message}) => {
  const dispatch = useAppDispatch()

  const handleClose = () => dispatch(hideModalThunk(null))

  useEffect(() => {
    setTimeout(() => {
      handleClose()
    }, TIME_SHOW_HINT)
  }, [])

  const isError = type === 'error'
  const isSuccess = type === 'success'

  return (
    <ModalWrap classes={{modal: styles.wrapper}}>
      <div className={clsx(styles.hint, isError && styles.error, isSuccess && styles.success)}>{message}</div>
    </ModalWrap>
  )
}
